import { apiClient } from '../lib/apiClient';

// Mirrors the provider-side discovery routes in
// backend/src/routes/care-team-auth.routes.ts

export type ConnStatus = 'pending' | 'active' | 'pending_provider_accept' | null;

export type CaregiverResult = {
  householdId: string;
  city: string;
  province: string | null;
  youthCount: number;
  isIndigenous: boolean | null;
  ageRange: string | null;
  connectionStatus: ConnStatus;
};

export type PendingRequest = {
  connectionId: string;
  householdId: string;
  city: string;
  province: string;
  youthCount: number;
  isIndigenous: boolean | null;
  ageRange: string | null;
  createdAt: string;
};

export const discoveryApi = {
  search: (city: string, province: string, indigenousOnly?: boolean) => {
    const p = new URLSearchParams();
    if (city) p.set('city', city);
    if (province) p.set('province', province);
    if (indigenousOnly) p.set('indigenousOnly', 'true');
    return apiClient.get<CaregiverResult[]>(`/care-team-auth/discover-caregivers?${p.toString()}`);
  },

  requestConnection: (householdId: string) =>
    apiClient.post<{ connectionId: string; status: string }>(
      '/care-team-auth/request-connection',
      { householdId },
    ),

  connectWithCode: (code: string) =>
    apiClient.post<{ connectionId: string; status: string }>('/care-team-auth/connect', { code }),

  pendingRequests: () =>
    apiClient.get<PendingRequest[]>('/care-team-auth/pending-requests'),

  acceptRequest: (connectionId: string) =>
    apiClient.post<void>(`/care-team-auth/pending-requests/${connectionId}/accept`),

  declineRequest: (connectionId: string) =>
    apiClient.post<void>(`/care-team-auth/pending-requests/${connectionId}/decline`),
};
